export enum ListsDashboardsActionEnum {
  setFilters = 'setFilters',
  toggleFilterValue = 'toggleFilterValue',
  resetFilters = 'resetFilters',
  loadFilterOptions = 'loadFilterOptions',
  setActiveMeasure = 'setActiveMeasure',
  setKanbanSort = 'setKanbanSort',
  setView = 'setView',
  setDistributionSort = 'setDistributionSort',
  setSortMetric = 'setSortMetric',
  setSide = 'setSide',
  setCompare = 'setCompare',
  setCombine = 'setCombine',
}
